<template>
  <div class="bg">
    <div v-if="currentList" class="tab-box">
      <div class="tab-item" @click="onTabChange('current')">
        <span :class="activeTab == 'current' ? 'tab-click' : ''">本期</span>
        <div v-if="activeTab == 'current'" class="tab-l"></div>
      </div>
      <div class="tab-item" @click="onTabChange('total')">
        <span :class="activeTab == 'total' ? 'tab-click' : ''">总计</span>
        <div v-if="activeTab == 'total'" class="tab-l"></div>
      </div>
    </div>
    <div class="interval"></div>

    <div class="type-box">
      <div class="type">
        <div class="type-item" :class="status ? 'type-click' : ''" @click="status=true">已点亮</div>
        <div class="type-item" :class="!status ? 'type-click' : ''" @click="status=false">未点亮</div>
      </div>
    </div>

    <div class="no-gift" v-if="displayList.length===0">暂无点亮的礼物</div>
    <div class="gift-box">
      <div v-for="(item,index) in displayList" :key="index" class="gift-item">
        <img class="gift-img" :class="item.giveCount > 0 ? '' : 'gift-off'" :src="item.imgUrl" :alt="item.name" />
        <div class="gift-name">{{item.name}}</div>
        <div class="gift-num">x{{item.giveCount}}</div>
        <div style="position: absolute;top: 0;left: 0; font-size: 9px;color: white;padding: 1px 3px;border-radius: 10px;"
             :style="item.isHideGift?'background: rgba(0, 0, 0, 0.89)':'background: #4FAAFD;'"
             v-if="$store.state.shop.id === 1834||$store.state.shop.id === 1">
          <span v-if="!item.isHideGift" @click="updateHideGiftEvent(item.id,true)">开启隐藏</span>
          <span v-else @click="updateHideGiftEvent(item.id,false)">隐藏中</span>
        </div>
      </div>

    </div>
  </div>

</template>
<script>
import Vue from 'vue';
import {Dialog, Icon, Tab, Tabs, Toast} from 'vant';
import {listClerkGift,updateHideGift} from "@/api/clerk/gift";

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
export default {
  name: "gift",
  props: [],
  components: {},
  computed:{
    displayList(){
      if(this.status){
        return this.activated
      }else{
        return this.inactivated
      }
    },
    activated(){
      return this._.filter(this.giftList,(item)=>{
        return item.giveCount > 0
      })
    },
    inactivated(){
      return this._.filter(this.giftList,(item)=>{
        return item.giveCount == 0
      })
    }
  },

  data() {
    return {
      activeTab: null,
      status: true,
      currentList: null,
      totalList: [],
      giftList:[]
    }
  },
  methods: {
    updateHideGiftEvent(id,isHideGift) {
      let op = isHideGift ?  '隐藏':'显示'
      Dialog.confirm({
        title: '确定要'+op+'礼物吗?'
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        updateHideGift(id, isHideGift).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            Toast.success('修改成功');
            this.loadData();
          } else {
            Dialog.alert({
              title: '修改失败',
              message: data.msg
            })
          }
        })
      })

    },
    loadData() {
      this.handlerPromise(listClerkGift(),(data)=>{
        this.currentList = data.currentList
        this.totalList = data.totalList
        if(this.currentList){
          this.giftList = this.currentList
        }else{
          this.giftList = this.totalList
        }
      })
    },
    onTabChange(name,title){
      if(name==='current'){
        this.activeTab = 'current'
        this.giftList = this.currentList
      }
      if(name==='total'){
        this.activeTab = 'total'
        this.giftList = this.totalList
      }
    },
    handlerPromise(promise, success, fail) {
      promise.then(res => {
        const data = res.data;
        if (data.code === 0) {
          success(data)
        } else {
          let title = '提示'
          if(fail){
            if ( typeof fail === 'string') {
              title = fail
            } else if(typeof fail === 'function') {
              fail(data)
              return;
            }
          }
          Dialog.alert({
            title: title,
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    this.loadData()
    this.onTabChange('current')
  }
}
</script>
<style lang="less" scoped>
.bg {
  min-width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  .tab-box{
    padding: 16px 94px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tab-item{
      position: relative;
      font-size: 14px;
      line-height: 14px;
      color: #999;
      font-weight: 500;
      .tab-click{
        color: #333;
        font-weight: bold;
      }
      .tab-l{
        width: 56px;
        height: 2px;
        border-radius: 999px;
        background: var(--primary-color);
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translate(-50%,-100%);
      }
    }
  }
  .interval{
    height: 7px;
    width: 100%;
    background: #f5f6f7;
  }
  .type-box{
    padding: 10px 21px;
    display: flex;
    justify-content: flex-end;
    background: #fff;
    .type{
      display: flex;
      align-items: center;
      background: #F5F7F7;
      border-radius: 999px;
      font-size: 11px;
      line-height: 25px;
      color: #979899;
      .type-item{
        width: 52px;
        height: 25px;
        text-align: center;
        border-radius: 999px;
      }
      .type-click{
        color: #fff;
        background: var(--primary-color);
      }
    }
  }

  .no-gift{
    text-align: center;
    font-size: 14px;
    color: #999;
  }

  .gift-box{
    padding: 0 13px;
    width: calc(100% - 13px * 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .gift-item{
      width: calc(33.33% - 5px);
      display: flex;
      align-items: center;
      flex-flow: column;
      padding: 11px 0 8px 0;
      margin-bottom: 7px;
      position: relative;
      .gift-img{
        height: 72px;
        display: block;
      }
      .gift-off{
        filter: grayscale(100%);
      }
      .gift-name{
        margin-top: 10px;
        font-size: 11px;
        line-height: 11px;
        color: #333;
      }
      .gift-num{
        margin-top: 5px;
        font-size: 11px;
        line-height: 11px;
        color: var(--primary-color);
      }
    }
  }
  .gift-box::after{
    content: '';
    width: calc(33.33% - 5px);
  }
}
</style>
